import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import * as moment from "moment";
import { Device } from "../../../models/device";
import { I18N } from "aurelia-i18n";

@autoinject
export class DecentlabWaterLevelChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

	calculateLevel(pressure: number): string {
		const level = (pressure / +this.device.properties.nominalPressure.value) * 100;
		if (isNaN(level) || level < 0) {
			return "0.0";
		}
		return (level >= 100 ? 100 : level).toFixed(1);
	}

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[1].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp).format("lll"));
				this.chartData.datasets[0].data.push(this.calculateLevel(item.data.pressure));
				this.chartData.datasets[1].data.push(this.convertTemperature(item.data.temperature));
			});
			this.chart.refreshChart();
		}
	}

	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			datasets: [
				{
					label: "% Full",
					backgroundColor: "rgba(0,0,255,0.2)",
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(220,220,220,1)",
					yAxisID: "Capacity",
					data: []
				},
				{
					label: `Temperature (${this.getTemperatureSymbol()})`,
					backgroundColor: "rgba(220,220,220,0.2)",
					borderColor: "rgba(220,220,220,1)",
					pointColor: "rgba(220,220,220,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(151,187,205,1)",
					yAxisID: "Temperature",
					data: []
				},
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						}
					}
				],
				yAxes: [
					{
						id: "Temperature",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Temperature"
						},
						position: "right"
					},
					{
						id: "Capacity",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Capacity"
						},
						position: "left"
					}
				]
			}
		};
	}
}
